<template>
    <div class="img-viewer" @click="clickImg()">
        <img v-if="!currentImg.slice(0, 5).includes('svg')" :src="currentImg" alt=""  />
        <div v-if="currentImg.slice(0, 5).includes('svg')" v-html="currentImg" ></div>
    </div>
</template>
<script>
export default {
    name: "ImgViewer",
    props: {
        currentImg: {
            type: String,
            default: ""
        }
    },
    methods: {
        clickImg() {
            this.$parent.showImgViewer=false
        }
    }
}
</script>
<style lang="less">
@import "../assets/color.less";

.img-viewer {
  position: fixed;
  overflow: auto;
  cursor: pointer;
  background-color: darken(@overlay, 80%);
  top: 0;
  z-index: 6001;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 5%;
  
  svg{
    background-color: #fff;
  }

  @media screen and (min-width: 960px) {
    img {
      width: initial;
      height: auto;
      background-color: white;
    }

    svg {
      width: initial;
      height: 100vh;
      max-height: 90vh;
    }
  }

  @media screen and (max-width: 959px) {
    img {
      width: initial;
      height: 100vh;
      max-height: 90vh;
      background-color: white;
    }

    svg {
      width: 100vw;
      max-width: 90vw;
      height: initial;
    }
  }
}
</style>